/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/22/18
 * Copyright All Rights Reserved
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const NavLinkGroup = ({ children, className }) => (
  <nav className={classNames('nav-link-group', className)}>
    {children}
  </nav>
);

NavLinkGroup.defaultProps = {
  className: '',
};

NavLinkGroup.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

export default NavLinkGroup;
